export type DevDocLink = {
  key: string
  label: string
  version?: string
  description: string
  url: string
}

export type DevDocSection = {
  key: string
  label: string
  description: string
  items: DevDocLink[]
}

export const devDocSections: DevDocSection[] = [
  {
    key: 'frontend',
    label: 'Frontend',
    description: 'React、构建、状态管理与 UI 相关文档',
    items: [
      { key: 'react', label: 'React', version: '19.2.6', description: 'React 19 官方文档', url: 'https://react.dev/' },
      { key: 'react-router', label: 'React Router', version: '7.18.0', description: '路由与数据加载', url: 'https://reactrouter.com/' },
      { key: 'tanstack-query', label: 'TanStack Query', version: '5.101.0', description: '服务端状态管理', url: 'https://tanstack.com/query/latest' },
      { key: 'antd', label: 'Ant Design', version: '6.5.0', description: '组件 API 与设计规范', url: 'https://ant.design/' },
      { key: 'antd-plots', label: 'Ant Design Plots', version: '2.6.8', description: '图表组件文档', url: 'https://ant-design-charts.antgroup.com/' },
      { key: 'zustand', label: 'Zustand', version: '5.0.14', description: '轻量状态管理', url: 'https://zustand.docs.pmnd.rs/' },
      { key: 'i18next', label: 'i18next', version: '26.3.1', description: '国际化框架文档', url: 'https://www.i18next.com/' },
      { key: 'axios', label: 'Axios', version: '1.18.1', description: 'HTTP 客户端文档', url: 'https://axios-http.com/' },
      { key: 'vite', label: 'Vite', version: '8.0.12', description: '前端构建与开发服务器', url: 'https://vite.dev/' },
      { key: 'typescript', label: 'TypeScript', version: '6.0.2', description: '类型系统与 TS 配置', url: 'https://www.typescriptlang.org/docs/' },
      { key: 'tailwind', label: 'Tailwind CSS', version: '3.4.19', description: '原子化样式与工具类', url: 'https://tailwindcss.com/docs/installation' },
      { key: 'eslint', label: 'ESLint', version: '10.3.0', description: '静态检查规则与配置', url: 'https://eslint.org/docs/latest/' },
      { key: 'svgr', label: 'SVGR', version: '8.1.0', description: 'SVG 转 React 组件', url: 'https://react-svgr.com/' },
      { key: 'ali-oss', label: 'Aliyun OSS SDK', version: '6.23.0', description: '阿里云 OSS JS SDK', url: 'https://github.com/ali-sdk/ali-oss' },
    ],
  },
  {
    key: 'backend',
    label: 'Backend',
    description: 'Go、Web 框架、ORM 与服务端基础库',
    items: [
      { key: 'go', label: 'Go', version: '1.25.8', description: 'Go 语言官方文档', url: 'https://go.dev/doc/' },
      { key: 'gin', label: 'Gin', version: '1.12.0', description: 'Gin Web 框架文档', url: 'https://gin-gonic.com/' },
      { key: 'gorm', label: 'GORM', version: '1.31.2', description: 'ORM 文档与指南', url: 'https://gorm.io/docs/' },
      { key: 'sarama', label: 'Sarama', version: '1.50.3', description: 'Kafka Go Client', url: 'https://github.com/IBM/sarama' },
      { key: 'mysql-driver', label: 'go-sql-driver/mysql', version: '1.10.0', description: 'MySQL Go Driver', url: 'https://github.com/go-sql-driver/mysql' },
      { key: 'jwt', label: 'golang-jwt/jwt', version: '5.3.1', description: 'JWT for Go', url: 'https://github.com/golang-jwt/jwt' },
      { key: 'cobra', label: 'Cobra', version: '1.10.2', description: 'CLI 框架文档', url: 'https://cobra.dev/' },
      { key: 'viper', label: 'Viper', version: '1.21.0', description: '配置管理库', url: 'https://github.com/spf13/viper' },
      { key: 'redis-go', label: 'go-redis', version: '9.21.0', description: 'Redis Go Client', url: 'https://github.com/redis/go-redis' },
      { key: 'nacos', label: 'Nacos Go SDK', description: '服务发现与配置中心 SDK', url: 'https://github.com/nacos-group/nacos-sdk-go' },
    ],
  },
  {
    key: 'infra',
    label: 'Infra',
    description: '本地开发依赖与基础设施文档',
    items: [
      { key: 'mysql', label: 'MySQL', version: '8.1.0', description: '数据库官方文档', url: 'https://dev.mysql.com/doc/' },
      { key: 'redis', label: 'Redis', description: '缓存与数据结构文档', url: 'https://redis.io/docs/latest/' },
      { key: 'kafka', label: 'Apache Kafka', version: '3.5.1', description: '消息队列官方文档', url: 'https://kafka.apache.org/documentation/' },
      { key: 'docker-compose', label: 'Docker Compose', description: '本地编排与开发环境', url: 'https://docs.docker.com/compose/' },
    ],
  },
]
